<template>
  <div id="calendar-menu">
    <div class="calendar-box-subheader calendar-text-center border-color-skin">
      <div  class="icon-layout bg-hover-color-skin-dark-10"
            v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab1Disp }"
            @click="toggleCalendar('calendarTab1Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star color-skin-dark-10 star-position' : foundCalendar.tab1, 'animated zoomOut fa fa-star star color-skin-dark-10 star-position' : !foundCalendar.tab1 }"></a>
        <img id="nav-img1" :src="require('static/images/icon_leave_dark.png')">
        <span class="icon-font">LEAVE</span>
        <div class="icon-layout-checkbox">
          <filter-checksquare v-model="btnFilter.tab1" v-show="filterImage"></filter-checksquare>
        </div>
      </div>
      <div  class="icon-layout bg-hover-color-skin-dark-10"
            v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab2Disp }"
            @click="toggleCalendar('calendarTab2Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star color-skin-dark-10 star-position' : foundCalendar.tab2, 'animated zoomOut fa fa-star star color-skin-dark-10 star-position' : !foundCalendar.tab2 }"></a>
        <img id="nav-img2" :src="require('static/images/icon_appointment_dark.png')">
        <span class="icon-font">APPOINTMENT</span>
        <div class="icon-layout-checkbox">
          <filter-checksquare v-model="btnFilter.tab2" v-show="filterImage" :setBtnFilter="setBtnFilter"></filter-checksquare>
        </div>
      </div>
      <div  class="icon-layout bg-hover-color-skin-dark-10"
            v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab3Disp }"
            @click="toggleCalendar('calendarTab3Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star color-skin-dark-10 star-position' : foundCalendar.tab3, 'animated zoomOut fa fa-star star color-skin-dark-10 star-position' : !foundCalendar.tab3 }"></a>
        <img id="nav-img3" :src="require('static/images/icon_training_dark.png')">
        <span class="icon-font">TRAINING</span>
        <div class="icon-layout-checkbox">
          <filter-checksquare v-model="btnFilter.tab3" v-show="filterImage" :setBtnFilter="setBtnFilter"></filter-checksquare>
        </div>
      </div>
      <div  class="icon-layout bg-hover-color-skin-dark-10"
            v-bind:class= "{ 'nav-active bg-color-skin-dark-10' : calendarTab4Disp }"
            @click="toggleCalendar('calendarTab4Disp')">
        <a :class="{ 'animated zoomIn fa fa-star star color-skin-dark-10 star-position' : foundCalendar.tab4, 'animated zoomOut fa fa-star star color-skin-dark-10 star-position' : !foundCalendar.tab4 }"></a>
        <img id="nav-img4" :src="require('static/images/icon_todolist_dark.png')">
        <span class="icon-font">TO DO LIST</span>
        <div class="icon-layout-checkbox">
          <filter-checksquare v-model="btnFilter.tab4" v-show="filterImage" :setBtnFilter="setBtnFilter"></filter-checksquare>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filterChecksquare from 'components/calendar/filterChecksquare'

export default {
  name: 'calendar_menu',
  props: [ 'calendarTab1Disp', 'calendarTab2Disp', 'calendarTab3Disp', 'calendarTab4Disp', 'filterImage', 'toggleCalendar', 'btnFilter', 'setBtnFilter', 'foundCalendar' ],
  components: {
    filterChecksquare
  }

}
</script>


// WEBPACK FOOTER //
// calendar_menu.vue?f614dc22